import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=549e8f3f&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=549e8f3f&prod&scoped=true&lang=scss"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=549e8f3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e8f3f",
  null
  
)

export default component.exports